import { Trans } from "@lingui/react/macro";
import { lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { GeolocationConsumer } from "~/hook/base/useGeolocation.ts";
import { usePokeWithGeolocation } from "~/hook/overlay/usePokeWithGeolocation.ts";
import { createDraggableSheet } from "~/ui/base/DraggableSheet.tsx";

const Map = lazy(() =>
  import("~/ui/base/Map.tsx").then((module) => ({ default: module.Map })),
);

export const PokeWithGeoLocationSheet = createDraggableSheet<{ email: string }>(
  ({ close, context: { email }, titleId }) => {
    const { disabled, domRef, handleSend, height, width } =
      usePokeWithGeolocation(email, close);

    return (
      <div className="p-6" data-testid="내 위치 찌르기">
        <h1
          className="text-lg font-semibold text-zinc-800 dark:text-zinc-100"
          id={titleId}
        >
          <Trans>내 위치 찌르기</Trans> 📍
        </h1>
        <div className="h-6"></div>
        <div
          className="relative aspect-square w-full overflow-hidden rounded-2xl"
          ref={domRef}
        >
          <ErrorBoundary
            fallback={
              <div className="dark:bg-zinc-850 size-full bg-zinc-100 p-5 text-zinc-700 dark:text-zinc-300">
                <Trans>사용할 수 없는 기기입니다.</Trans>
              </div>
            }
          >
            <Suspense
              fallback={
                <div className="dark:bg-zinc-850 size-full animate-pulse bg-zinc-100"></div>
              }
            >
              <GeolocationConsumer>
                {(position) =>
                  height > 0 &&
                  position && (
                    <Map
                      height={height}
                      position={position.coords}
                      width={width}
                    />
                  )
                }
              </GeolocationConsumer>
            </Suspense>
          </ErrorBoundary>
        </div>
        <div className="pt-10">
          <button
            className="h-12 w-full rounded-2xl bg-black font-medium text-white duration-300 active:bg-zinc-300 disabled:bg-zinc-300 dark:bg-zinc-800 dark:active:bg-zinc-700 dark:disabled:bg-zinc-900"
            disabled={disabled}
            onClick={handleSend}
            type="button"
          >
            <Trans>찌르기</Trans> 👉
          </button>
        </div>
      </div>
    );
  },
);
